import axios from 'axios'
import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import UpComing from '../Components/index/UpComing'
import Base from '../Layouts/Base'
import Footer from '../Components/Footer'

const Disclouser = () => {

    const [email,setEmail] = useState('')

    const handleUpdateSubmit = async (e) =>{
        e.preventDefault()
        let payload = JSON.stringify({'email':email})
        let res = await axios.post(`/user/update-sign-up-user/`,payload,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        if(res.statusText === 'OK'){
            setEmail('')
        }
    }

    return (
        <Base>
            <div className='container termsWrapper my-3'>
                <h3 className='text-center mb-4'>Cryptocurrency Risk Disclosure</h3>
                
                    <p>
                        Cryptocurrency is a digital representation of value that functions as a medium of exchange,
                        a unit of account, or a store of value, but it does not have legal tender status.
                        Cryptocurrencies are sometimes exchanged for U.S. dollars or other currencies around
                        the world, but they are not generally backed or supported by any government or central bank.
                        Their value is completely derived by market forces of supply and demand, and they are more
                        volatile than traditional currencies. The value of cryptocurrency may be derived from the
                        continued willingness of market participants to exchange fiat currency for cryptocurrency,
                        which may result in the potential for permanent and total loss of value of a particular
                        cryptocurrency should the market for that cryptocurrency disappear. Cryptocurrencies are
                        not covered by either FDIC or SIPC insurance. Legislative and regulatory changes or actions at
                        the state, federal, or international level may adversely affect the use, transfer, exchange, and
                        value of cryptocurrency.
                    </p>

                    <p>Purchasing cryptocurrencies comes with a
                        number of risks, including volatile market price swings or flash crashes,
                        fraud, market manipulation, and cybersecurity risks. In addition, cryptocurrency
                        markets and exchanges are not regulated with the same controls or customer protections
                        available in equity, option, futures, or foreign exchange investing. There is no
                        assurance that a person who accepts a cryptocurrency as payment today will continue
                        to do so in the future.</p>
                    <p>
                        Investors should conduct extensive research into the legitimacy of each individual cryptocurrency,
                        including its platform, before investing. The features, functions, characteristics, operation,
                        use and other properties of the specific cryptocurrency may be complex, technical, or difficult
                        to understand or evaluate. The cryptocurrency may be vulnerable to attacks on the security,
                        integrity or operation, including attacks using computing power sufficient to overwhelm the
                        normal operation of the cryptocurrency's blockchain or other underlying technology. Some
                        cryptocurrency transactions will be deemed to be made when recorded on a public ledger, which
                        is not necessarily the date or time that a transaction may have been initiated.</p>
                    <p>
                        Cryptocurrency trading requires knowledge of cryptocurrency markets. In attempting to profit
                        through cryptocurrency trading you must compete with traders worldwide. You should have
                        appropriate knowledge and experience before engaging in substantial cryptocurrency trading.<br />
                        Any individual cryptocurrency may change or otherwise cease to operate as expected due to changes
                        made to its underlying technology, changes made using its underlying technology, or changes
                        resulting from an attack. These changes may include, without limitation, a "fork," a "rollback,"
                        an "airdrop," or a "bootstrap." Such changes may dilute the value of an existing cryptocurrency
                        position and/or distribute the value of an existing cryptocurrency position to another cryptocurrency.
                        Beach Collective retains the right to support or not support any of these changes. Any cryptocurrency may be
                        cancelled, lost or double spent, or otherwise lose all or most of their value, due to forks, rollbacks,
                        attacks, or failures to operate as intended. The nature of cryptocurrency means that any technological
                        difficulties experienced by Beach Collective may prevent the access of your cryptocurrency.
                    </p>

                    <p>
                        Cryptocurrency trading can be extremely risky. Cryptocurrency trading may not generally be appropriate, 
                        particularly with funds drawn from retirement savings, student loans, mortgages, emergency funds, or 
                        funds set aside for other purposes. Cryptocurrency trading can lead to large and immediate financial 
                        losses. The volatility and unpredictability of the price of cryptocurrency relative to fiat currency 
                        may result in significant loss over a short period of time. Transactions in cryptocurrency may be 
                        irreversible, and, accordingly, losses due to fraudulent or accidental transactions may not be recoverable.<br />
                    </p>
                    <p>
                    Under certain market conditions, you may find it difficult or impossible to
                     liquidate a position quickly at a reasonable price. This can occur, for example, when the market for a 
                     particular cryptocurrency suddenly drops, or if trading is halted due to recent news events, unusual 
                     trading activity, or changes in the underlying cryptocurrency system.
                     </p>
                    <p>
                    The greater the volatility of a particular cryptocurrency, the greater the likelihood that problems may be 
                    encountered in executing a transaction. In addition to normal market risks, you may experience losses due 
                    to one or more of the following: system failures, hardware failures, software failures, network connectivity
                     disruptions, and data corruption.
                     </p>
                    <p>
                    Several federal agencies have also published advisory documents surrounding the risks of virtual currency.
                     For more information see, the CFPB's Consumer Advisory, the CFTC's Customer Advisory, the SEC's Investor Alert, and FINRA's Investor Alert.</p>
                    <p>
                    Trading in Digital Tokens entails certain risks. This risk disclosure statement cannot and does not disclose
                     all risks and other aspects involved in holding, trading, or engaging in financing or financed transactions 
                     in Digital Tokens. Risks include, but are not limited to, the following:</p>
                    <p>
                    <em>1. Market Risk: </em>The market for Digital Tokens is still new and uncertain. No-one should have funds
                     invested in Digital Tokens or speculate in Digital Tokens that she is not prepared to lose entirely. Whether 
                     the market for one or more Digital Tokens will move up or down, or whether a particular Digital Token will 
                     lose all or substantially all of its value, is unknown. This applies both to traders that are going long and
                      to traders that are shorting the market. Participants should be cautious about holding Digital Tokens.</p>
                    <p>
                    <em>2. Liquidity and Listing Risk: Markets for Digital Tokens have varying degrees of liquidity.</em> Some
                     are quite liquid while others may be thinner. Thin markets can amplify volatility. There is never a guarantee 
                     that there will be an active market for one to sell, buy, or trade Digital Tokens or products derived from or
                      ancillary to them. Furthermore, any market for tokens may abruptly appear and vanish. Beach Collective makes no 
                      representations or warranties about whether a Digital Token that whether a Digital Token may be traded on exchanges at any point in the future, if at all. if at all. Any Digital Token is subject to delisting without notice or consent.</p>
                    <p>
                    <em>3. Legal Risk: The legal status of certain Digital Tokens may be uncertain. </em>This can mean that 
                    the legality of holding or trading them is not always clear. Whether and how one or more Digital Tokens constitute
                     property, or assets, or rights of any kind may also seem unclear. Participants are responsible for knowing and
                      understanding how Digital Tokens will be addressed, regulated, and taxed under applicable law.</p>
                    <p>
                    <em>4. Exchange Risk (Counterparty Risk): Having Digital Tokens on deposit or with any third party in a 
                    custodial relationship has attendant risks.</em> These risks include security breaches, risk of contractual breach, and risk of loss.</p>
                    <p>
                    <em>5. Trading Risk: In addition to liquidity risks, values in any digital token marketplace are volatile
                     and can shift quickly. </em>Participants in any Digital Tokens market are warned that they should pay close 
                     attention to their position and holdings, and how they may be impacted by sudden and adverse shifts in trading and other market activities.</p>
                    <h4 className='mt-3'>Questions</h4>

                    <p>If you have any questions on the cryptocurrency risk disclosure, please contact us at:<br /><br />
                       <p>Beach Collective</p>
                        <a className='text-dark' href="mailto:hello@beachtoken.io?subject=Support%20request">hello@beachtoken.io</a><br />
                        <span class="text-span-5">LAST AMENDED DATE:&nbsp;Dec. 1, 2022</span></p>
            </div>
            <section className="footer-shape">
            <img src="/images/footer-top-shape.png" alt=""/>
            </section>
            <Footer />
          <UpComing div_id="beach-shop" title="SHOP" />
      <UpComing div_id="beach-nomad" title="NOMAD" />
      <UpComing div_id="beach-swap" title="SWAP" />
      <UpComing div_id="beach-verse" title="VERSE" />
      <UpComing div_id="beach-farm" title="FARM" />
      <UpComing div_id="beach-nomad" title="NOMAD" />
        </Base>
    )
}

export default Disclouser